export enum RouterEnum {
  LOGIN = "/login",
  DASHBOARD = "/",
  REPORTS = "/reports",
  SUPPORT = "/support",
  ADMIN_USERS = "/admin/users",
  ADMIN_AREA01_PRODUCTS = "/admin/area01-products",
  ADMIN_UNLINKED_EANS = "/admin/unlinked-eans",
  ADMIN_CARD_INVENTORY = "/admin/card-inventory",
}
